import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import UserDetails from 'v2/pages/Users/Details/UserDetails';
import UserGroupDetails from 'v2/pages/Users/Groups/Details/UserGroupDetails';
import UserGroupOverview from 'v2/pages/Users/Groups/Overview/UserGroupOverview';
import UsersOverview from 'v2/pages/Users/Overview/Overview';

const Users: React.FC<React.PropsWithChildren> = () => (
  <PageLayout>
    <Routes>
      <Route path="/groups/overview" element={<UserGroupOverview />} />
      <Route path="/groups/:groupId" element={<UserGroupDetails />} />
      <Route path="/groups" element={<Navigate to="overview" replace />} />
      <Route path="/overview" element={<UsersOverview />} />
      <Route path="/:userId" element={<UserDetails />} />
      <Route path="/" element={<Navigate to="overview" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageLayout>
);

export default Users;
